import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { environment } from '../../environments/environment';

export interface RaidItem {
  id: string;
  projectId: string;
  itemNumber: string;
  type: string;
  description: string;
  identifiedDate: string;
  impact: string;
  owner: string;
  targetDate?: string;
  status: string;
  mitigationPlan?: string;
  dateClosed?: string;
  remark?: string;
}

export interface CreateRaidItemDto {
  projectId: string;
  itemNumber: string;
  type: string;
  description: string;
  identifiedDate: string;
  impact: string;
  owner: string;
  targetDate?: string;
  status: string;
  mitigationPlan?: string;
  dateClosed?: string;
  remark?: string;
}

@Injectable({
  providedIn: 'root'
})
export class RaidItemService {
  private apiUrl = `${environment.apiUrl}/RaidItem`;

  constructor(private http: HttpClient) { }

  getByProjectId(projectId: string): Observable<RaidItem[]> {
    return this.http.get<RaidItem[]>(`${this.apiUrl}/project/${projectId}`);
  }

  getById(id: string): Observable<RaidItem> {
    return this.http.get<RaidItem>(`${this.apiUrl}/${id}`);
  }

  addItem(item: CreateRaidItemDto): Observable<RaidItem> {
    return this.http.post<RaidItem>(this.apiUrl, item);
  }

  updateItem(id: string, item: RaidItem): Observable<RaidItem> {
    return this.http.put<RaidItem>(`${this.apiUrl}/${id}`, item);
  }

  deleteItem(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}


